/**
 * @fileoverview Reports hub content (AR-545) — title + the available report
 * cards. Rendered inside the existing Reports dashboard route when the Arc flag
 * is on, so it relies on its host (ReportsDashboard) for the Layout shell.
 * Ships with a single card (Development report); more cards land here as the
 * other report types are built.
 */

import { SimpleGrid } from '@mantine/core'
import { IconChartLine, IconClipboardCheck, IconFileText } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { ArcPageShell } from 'components/ArcPageShell'
import { ReportCard } from './components/ReportCard'

const GRID_BREAKPOINTS = [
  { maxWidth: 'md', cols: 2 },
  { maxWidth: 'sm', cols: 1 },
]

export function ArcReportsContent() {
  const { t } = useTranslation()

  return (
    <ArcPageShell title={t('reports_hub.title')} subtitle={t('reports_hub.subtitle')}>
      <SimpleGrid cols={3} spacing='md' breakpoints={GRID_BREAKPOINTS}>
        <ReportCard
          icon={<IconFileText size={24} />}
          color='blue'
          title={t('reports_hub.report_cards.title')}
          description={t('reports_hub.report_cards.description')}
          to='/end_of_term_reports'
          external
        />
        <ReportCard
          icon={<IconClipboardCheck size={24} />}
          color='orange'
          title={t('reports_hub.assessment_reports.title')}
          description={t('reports_hub.assessment_reports.description')}
          to='/students/reports'
          external
        />
        <ReportCard
          icon={<IconChartLine size={24} />}
          title={t('reports_hub.development_report.title')}
          description={t('reports_hub.development_report.description')}
          to='/app/development-report'
        />
      </SimpleGrid>
    </ArcPageShell>
  )
}
